module.exports = __webpack_public_path__ + "static/media/bouteille-eau.f1cde302.svg";